module.exports = __webpack_public_path__ + "static/media/greycat2.573b53c7.png";